<template>
  <mobile v-if="isMobile" /> <desktop v-else />
</template>

<script>
import { mapGetters } from 'vuex';

import mobile from './mobile';
import desktop from './desktop';

export default {
  name: 'FooterNavigation',
  components: {
    desktop,
    mobile,
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
};
</script>



// WEBPACK FOOTER //
// src/elements/LoginIndicator/index.vue